import { RouterType } from '@online-webinar/router';
import { EditSubtitlesPage } from '@online-webinar/webinar-management';
import { authGuard } from '../integrations/auth-guard';

export const updateRoute = (router: RouterType) => {
    router.routesById['/$webinarId/edit-subtitles'].update({
        staticData: { title: { page: 'EditSubtitles.PageHeading', forWebinar: true } },
        component: authGuard(EditSubtitlesPage, { canBroadcast: true })
    });
};
